document.addEventListener('DOMContentLoaded', function () {
  // Singleton modal for all videos
  let videoModal = null;

  function closeModal() {
    if (videoModal) {
      videoModal.remove();
      videoModal = null;
      // Optionally: Restore scroll
      document.body.style.overflow = '';
    }
  }

  document.querySelectorAll('.video-thumbnail').forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {

      const videoUrlRaw = thumbnail.getAttribute('data-video-url');
      if (!videoUrlRaw) return;
      let videoUrl = '';
      if (videoUrlRaw.includes('youtube.com') || videoUrlRaw.includes('youtu.be')) {
        if (videoUrlRaw.includes('watch?v=')) {
          videoUrl = videoUrlRaw.replace('watch?v=', 'embed/');
        } else if (videoUrlRaw.includes('youtu.be')) {
          videoUrl = videoUrlRaw.replace('youtu.be/', 'www.youtube.com/embed/');
        } else {
          videoUrl = videoUrlRaw;
        }
        videoUrl += '?autoplay=1';
      } else if (videoUrlRaw.includes('vimeo.com')) {
        const match = videoUrlRaw.match(/vimeo\.com\/(\d+)/);
        console.log(match);
        if (match && match[1]) {
          videoUrl = `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
        } else {
          alert('Invalid Vimeo URL!');
          return;
        }
      } else {
        alert('Unsupported video URL!');
        return;
      }

      // Remove any existing modal before rendering a new one
      closeModal();

      // Build modal HTML
      videoModal = document.createElement('div');
      videoModal.className = 'video-modal';
      videoModal.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 99999;
        top: 0; left: 0; width: 100vw; height: 100vh;
        background: rgba(0,0,0,0.95);
      `;

      videoModal.innerHTML = `
        <div style=" width: 82vw; aspect-ratio: 16/9; background: #000;">
          <button class="modal-close" style="position:absolute;top:12px;right:24px;font-size:36px;color:white;background:none;border:none;z-index:2;cursor:pointer;">✖</button>
          <iframe src="${videoUrl}" frameborder="0" allowfullscreen allow="autoplay; encrypted-media" style="width:100%;height:100%;border:none;display:block;z-index:1;"></iframe>
        </div>
      `;

      document.body.appendChild(videoModal);
      document.body.style.overflow = 'hidden'; // Prevent scroll behind modal

      // Close actions
      videoModal.querySelector('.modal-close').onclick = closeModal;
      videoModal.addEventListener('click', function (evt) {
        if (evt.target === videoModal) closeModal();
      });
      document.addEventListener('keydown', function escListener(e) {
        if (e.key === 'Escape') {
          closeModal();
          document.removeEventListener('keydown', escListener);
        }
      });
    });
  });
});





// Swatch chnages
function updateVariantSwatchInfo() {
  var color = '';
  var style = '';
  var checkedInput = document.querySelector('input[type="radio"][data-variant-id]:checked');
  if (checkedInput) {
    color = checkedInput.dataset.variantSwatchColor || '';
    style = checkedInput.dataset.variantSwatchStyle || '';
  }

  var metaColorStyleDiv = document.querySelector('.meta-color-style');
  if (color && style) {
    metaColorStyleDiv.style.display = 'block';
    document.getElementById('variant-color').textContent = color;
    document.getElementById('variant-style').textContent = style;
  } else {
    metaColorStyleDiv.style.display = 'none';
    document.getElementById('variant-color').textContent = '';
    document.getElementById('variant-style').textContent = '';
  }
}


// On page load
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(updateVariantSwatchInfo, 3000); // Delay to allow all AJAX/theme JS to finish
});

// On change
document.addEventListener('change', function (event) {
  if (event.target.matches('input[type="radio"][data-variant-id]')) {
    setTimeout(updateVariantSwatchInfo, 3000);
  }
});

// On Shopify section/ajax redraw
document.addEventListener('shopify:section:load', function () {
  setTimeout(updateVariantSwatchInfo, 3000);
});

document.addEventListener('variant:change', function () {
  setTimeout(updateVariantSwatchInfo, 3000);
});





